/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { TokenStorage } from "../../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerGroupService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code, params) {
    const requestScreenData = {
      url: "api/CustomerGroup",
      top: "1",
      filter: `Code eq '${code}'`,
    };
    if (params) {
      if (params.select) requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, customerGroup) {
    var payload = customerGroup;
    var url = "api/CustomerGroup";

    if (mode == "create") {
      return await ApiService.post(
        url,
        payload,
        "String"
      );
    }
    else {
      return await ApiService.patch(url, customerGroup.Code, payload, "String");
    }
  },
  async markAsDefault(payload) {
    let url = "api/Save_DefaultCustomerGroup"
    return await ApiService.post(url, payload);
  },

  async getItems(requestParams) {
    return await ApiService.oDataGet(requestParams);
  },
};

export { CustomerGroupService };
